import React from 'react';
import { LoadingContainer, Spinner, LoadingText } from './Loading.styles';

const Loading = ({ text = 'Cargando...' }) => {
  return (
    <LoadingContainer>
      <Spinner />
      <LoadingText>{text}</LoadingText>
    </LoadingContainer>
  );
};

export default Loading;
